module.exports = __webpack_public_path__ + "tile-3-overlay-2MpETeP.webp";